module.exports = __webpack_public_path__ + "static/media/donkey-man.306a9099.png";